// extracted by mini-css-extract-plugin
export default {"form_group":"FormSelect_form_group__TbVAy","label":"FormSelect_label__VfYTf","select_box":"FormSelect_select_box__SM0Du","button":"FormSelect_button__BCrAV"};